<!-- 
	This is the sign in page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>

	<a-spin :spinning="isLoading" size="large">
        <guest-entry v-if="type == 'ANONYM' && state == 'AUTH'" @success="onUserAuthSuccess" /> 
        <live-official v-if="type == 'OFFICIAL'" />          
        <live-user v-if="state == 'AUTH_SUCCESS'" :auth-data="authData" />
    </a-spin>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { navigationMixin } from "../mixins/navigation-mixin.js";
import { toastMixin } from "../mixins/ToastMixin.js";
import { useAuthStore } from '../stores/auth-store';
// import { BanglaUtils } from "../helpers/bangla-utils.js";

import GuestEntry from '../views/live-communications/GuestEntry.vue';
import LiveOfficial from '../views/live-communications/LiveOfficial.vue';
import LiveUser from '../views/live-communications/LiveUser.vue';

export default ({
    components: {
        GuestEntry,
        LiveOfficial,
        LiveUser
    },
    mixins: [ navigationMixin, toastMixin ],
    data() {
        return {
            state: '',
            
            authData: {},

            
            rememberMe: false,
            value:{},
            userName: "",
            password:"",
           
            isLoading: false,
        }
    },
    computed: {
        ...mapState(useAuthStore, [ 'currentUser' ]),
        isOfficial() {
            return (this.currentUser && this.currentUser.roles && this.currentUser.roles.includes('OFFICIAL'))
        },
        type() {
            if (!this.currentUser)
                return 'ANONYM';
            else if (this.isOfficial)
                return 'OFFICIAL';
            else
                return '';
        }
    },
    methods: {
        
        navigateToDashboard(){
            this.navigateTo('Dashboard');
        },
        onUserAuthSuccess(authData) {
            // console.log(authData);
            this.authData = authData;
            this.state = 'AUTH_SUCCESS';
        }
        
    },
    mounted() {
        if (!this.currentUser) {
            this.state = 'AUTH';
        } 
    }
})

</script>

<style lang="scss">
body {
    background-color: #ffffff;
}
</style>